import { render, staticRenderFns } from "./RequestPage.vue?vue&type=template&id=fde8d460&scoped=true&"
import script from "./RequestPage.vue?vue&type=script&lang=js&"
export * from "./RequestPage.vue?vue&type=script&lang=js&"
import style0 from "./RequestPage.vue?vue&type=style&index=0&id=fde8d460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde8d460",
  null
  
)

export default component.exports